<template>
  <v-layout align-center row wrap>
    <v-flex
      v-for="filter in filters"
      :key="filter.key"
      filter_columns
    >
      <v-select
        v-if="validators.isCheckBox(filter.component)"
        v-model="filter.value"
        :items="filter.options"
        :label="filter.label || $t(filter.key)"
        :success="filter.value && filter.value.length && filter.value.length > 0"
        attach
        multiple
        @input="$emit('input', filter)"
      />

      <v-flex v-else-if="validators.isSlider(filter.component)">
        <v-layout row>
          <v-flex class="mr5">
            <v-text-field
              v-model="filter.value[0]"
              :label="filter.label || $t(filter.key)"
              :success="filter.value[0] > 0"
              min="0"
              type="number"
              @input="checkSliderFilter(filter)"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="filter.value[1]"
              :rules="[() => sliderRule(filter) || $t('Max_more_min')]"
              :success="filter.value[1] > 0"
              min="0"
              placeholder="Max"
              type="number"
              @input="checkSliderFilter(filter)"
            />
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex
        v-else-if="validators.isSingleCheckBox(filter.component)"
        class="justify-center"
        row
      >
        <filter-control-single-checkbox
          :filter="filter"
          :value="getValue(filter)"
          @input="$emit('input', $event)"
        />
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import FilterControlSingleCheckbox from './FilterControlSingleCheckbox.vue';

export default {
  name: 'FilterControls',
  components: { FilterControlSingleCheckbox },
  props: {
    filters: {
      type: Array,
      required: true,
    },
    validators: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    checkSliderFilter(filter) {
      if (this.sliderRule(filter)) {
        this.$emit('input', filter);
      }
    },
    sliderRule(filter) {
      return !filter.value[1]
        || parseInt(filter.value[1], 10) >= parseInt(filter.value[0], 10);
    },
    getValue({ key }) {
      const activeFilter = this.value.find(activeFilter => activeFilter.key === key);

      return activeFilter ? activeFilter.value : undefined;
    },
  },
};
</script>

<style lang="scss">
.mr5 {
  margin-right: 5px;
}

.filter_columns {
  padding: 0 10px !important;
}
</style>
